// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WGPj","badges":"styles_badges__1PfMT"};